<script>
  import Header from './components/Header.svelte';
  import ProcedureList from './components/ProcedureList.svelte';
  import Form from './components/form/Form.svelte';
  import {
    config,
    isLoadingProcedure,
    procedurePriceList,
    selectedProcedures,
    step,
  } from '../../../../../store/common';
  import API from '../../../../../api';

  let values = {};
  let isValid = false;

  const onClickGetPrice = () => {
    let dataLead = new FormData();
    let newArr = [];

    const isArea = (data, id) => {
      let is = false;

      data.forEach(item => {
        if (Object.keys(item)[0] === id) {
          is = true;
        }
      });

      return is;
    };

    const isPart = (data, areaId, partId) => {
      let is = false;

      data.forEach(area => {
        if (Object.keys(area)[0] === areaId) {
          if (Object.keys(area[areaId]).includes(partId)) {
            is = true;
          }
        }
      });

      return is;
    };

    $selectedProcedures.forEach(i => {
      if (!newArr.length || !isArea(newArr, i.body_area)) {
        newArr.push({
          [i.body_area]: {
            [i.body_part]: [i.procedure_id],
          },
        });
      } else if (
        isArea(newArr, i.body_area) &&
        !isPart(newArr, i.body_area, i.body_part)
      ) {
        newArr = newArr.map(item => {
          if (Object.keys(item)[0] === i.body_area) {
            item[i.body_area] = {
              ...item[i.body_area],
              [i.body_part]: [i.procedure_id],
            };

            return item;
          }

          return item;
        });
      } else {
        newArr = newArr.map(area => {
          if (Object.keys(area)[0] === i.body_area) {
            for (let key in area[i.body_area]) {
              if (i.body_part === key) {
                area[i.body_area][i.body_part].push(i.procedure_id);
              }
            }
          }

          return area;
        });
      }
    });

    dataLead.append('token', $config.token);
    dataLead.append('type', 'instant quote');
    dataLead.append('data[email]', values.email);
    dataLead.append('data[name]', values.name);
    dataLead.append('data[message]', values.message);
    dataLead.append('data[phone]', values.phone);
    dataLead.append('data[procedures]', JSON.stringify(newArr));

    for (let i = 0; i < values.files?.length; i++) {
      dataLead.append(`files[${i}]`, values.files[i]);
    }

    console.log('$selectedProcedures', $selectedProcedures);

    const selected_services = $selectedProcedures.map(item => ({
      customer_service_id: item.procedure_id,
      body_area: item.body_area,
      body_part: item.body_part,
    }));

    const dataPrice = {
      customer_id: $config.customerId,
      selected_services,
    };

    isLoadingProcedure.set(true);

    const params = { 'Content-Type': 'multipart/form-data' };

    API.getPrices(dataPrice)
      .then(({ data }) => {
        procedurePriceList.set(data);

        dataLead.append('data[price][from]', data.min_total_price);
        dataLead.append('data[price][to]', data.max_total_price);

        API.postLead(dataLead, null, params)
          .then(() => step.set(4))
          .catch(err => console.log('err', err))
          .finally(() => isLoadingProcedure.set(false));
      })
      .catch(err => console.log('err', err));
  };
  const onClickBack = () => {
    step.set(2);
  };

  const setValues = data => (values = { ...data });
  const setValid = data => (isValid = data);
</script>

<div class="uk-modal-body">
  <Header />

  <ProcedureList />

  <Form {setValues} {setValid} />
</div>

<div class="uk-modal-footer">
  <a
    class="uk-button uk-button-primary uk-width {!isValid && 'uk-disabled'}"
    on:click={onClickGetPrice}
  >
    Get Price Quote
    {#if $isLoadingProcedure}
      <div uk-spinner />
    {/if}
  </a>

  <a
    class="uk-button uk-button-default uk-width uk-margin-small-top"
    on:click={onClickBack}
  >
    Back to procedures
  </a>
</div>
